import React from 'react'
import cn from 'classnames';
import { analytics, getClickHeaderNavigation } from '@/utils/analytics';
import { getContent } from '@/utils/helper';

import Text from '@/atoms/Text/Text'
import { CtaWrapper } from '@/molecules/CTA';
import { DynamicAsset } from '@/molecules/Media';

function SectionVideoGrid({ entries = [], fields = {} }) {
  const {
    backgroundColor,
    cards,
  } = fields;

  const cardList =
    cards?.length > 0
      ? cards.map((card) => {
        const cardContent = getContent(card.sys.id, entries)?.fields;
        const ctaContent = getContent(cardContent.primaryCTA.sys.id, entries)?.fields;

        return {
          ...cardContent,
          cta: ctaContent,
        }
      })
    : [];

  const handleMenuClick = (e, url) => {
    analytics({
      window,
      document,
      detail: getClickHeaderNavigation(e, { url }),
    });
  };

  return (
    <div className={cn(
      "aaco-section-video-grid relative py-10", {
        [`bg-${backgroundColor}`]: backgroundColor !== undefined,
      }
    )}>
      <div className="aaco-section-video-grid__wrapper container mx-auto my-0">
        <div className="aaco-section-video-grid__content grid grid-cols-1 md:grid-cols-2 gap-[50px]">
          {cardList.map((data, index) => {
            return (
              <CtaWrapper
                page={data.cta.link}
                onClick={(e) => handleMenuClick(e, data.cta.link)} key={index}
                classNames={cn(
                  "aaco-section-video-grid__content__item flex flex-col max-w-[600px] border-b-1 border-black", {
                    "ml-auto": index % 2,
                    "mr-auto": !(index % 2),
                  }
                )}
              >
                <div className="aaco-section-video-grid__content__item__image border-black border-[1.82px] border-solid">
                  <DynamicAsset
                    assets={data.cloudinaryAssets}
                    entries={entries}
                    field={data.cloudinaryAssets}
                    container="half-container"
                    style="aspect-[67/84] md:aspect-[4/5]"
                  />
                </div>
                <div className="aaco-section-video-grid__content__item__text flex flex-row w-full justify-between h-[80px] md:h-[100px] items-center">
                  <Text
                    tag="h4"
                    style="text-black"
                  >
                    {data.title}
                  </Text>
                  <Text
                    tag="caption"
                    style={`text-black border-l-1 border-l-black pl-2 mr-4 md:mr-0 md:pl-4 whitespace-pre`}
                  >
                    {data.subtitle}
                  </Text>
                </div>
              </CtaWrapper>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default SectionVideoGrid
